import React, { useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { TBannerSectionProps } from './definitions';
import Styles from './BannerSection.module.scss';
import { sliderBanner } from '../../../../../actions/slidersAction';
import { connect } from 'react-redux';

const BannerSection: React.FC<TBannerSectionProps> = ({
  sliderBanner,
  category,
  sliderImages,
  isMobileView,
}) => {
  useEffect(() => {
    const params = { params: { category: 'all_category' } };
    sliderBanner(params);
  }, [category]);

  function onPress(redirect_url) {
    window.open(redirect_url, '_blank');
  }

  if (isMobileView) {
    return (
      <div className={Styles['wrapper']}>
        <div className={Styles['banner-container']}>
          {sliderImages.map((item, index) => {
            // Map through array of slides
            if (
              item?.images &&
              item.images.find((item) => (item.orientation = 'portrait'))
            ) {
              const key = `banner-mobile-${index}`;
              let images = item.images.find(
                (slide) => slide.orientation === 'portrait',
              );
              return (
                <KickImage
                  key={key}
                  src={images?.URL}
                  className={Styles['banner-image']}
                  onClick={() => onPress(item.redirect_url)}
                  cdnWidth={1000}
                />
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  }

  return (
    <div className={Styles['wrapper']}>
      <div className={Styles['banner-container']}>
        {sliderImages.map((item, index) => {
          const key = `banner-${index}`;
          // Map through array of slides
          return (
            <KickImage
              key={key}
              src={item.img_url}
              className={Styles['banner-image']}
              onClick={() => onPress(item.redirect_url)}
              cdnWidth={10000}
            />
          );
        })}
      </div>
    </div>
  );
};

interface Images {
  images: Array<Object>;
}
interface State {
  sliderHome: Images;
}

const mapStateToProps = (state: State) => ({
  sliderImages: state.sliderHome.images,
});

const mapDispatchToProps = (dispatch: any) => ({
  sliderBanner: (payload: Object) => dispatch(sliderBanner(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BannerSection);
